export default "/assets/images/the-critter-cuddler-crop.webp?242cc3389fbe3679a5b19f8f54b1d243";